import { Currency } from "@zapier/currency";
import { CurrencyRulesetItem } from "@zapier/payment";

/**
 *  Determine if the current payment source is unsupported by the given currency ruleset
 */
export const unsupportedPaymentSource = (
  currencyRuleset: any,
  primarySource: any,
  selectedCurrency: Currency
) => {
  const rulesetFilteredByCurrency = currencyRuleset.filter(
    (rule: CurrencyRulesetItem) => rule.currency === selectedCurrency.name
  );

  const supportedPaymentMethods = rulesetFilteredByCurrency.map(
    (rule: CurrencyRulesetItem) => rule.method
  );

  const supportedPaymentSubmethods = rulesetFilteredByCurrency.map(
    (rule: CurrencyRulesetItem) => rule.submethod
  );

  return (
    (primarySource?.method &&
      !supportedPaymentMethods.includes(primarySource.method)) ||
    (primarySource?.submethod &&
      !supportedPaymentSubmethods.includes(primarySource.submethod))
  );
};
